export enum MeasuresTab {
  Overview = 'OVERVIEW',
  Packages = 'PACKAGES',
}
